import React from 'react'
import PropTypes from 'prop-types'
import Style from './location.less'
import { UtilPhone } from '../../../utils'
import { UtilDevice, Bridge } from '@iskytrip/sdk'

import WARN_PNG from '@assets/components/warn.png'
import CHOOSE_PNG from '@assets/components/choose.png'
import REFRESH_PNG from '@assets/components/refresh.png'
import LOADING_PNG from '@assets/components/loading.png'
import REFRESHYELLOW_PNG from '@assets/components/refreshyellow.png'

class Location extends React.Component {
	static propTypes = {
		_showOrhide: PropTypes.func,
		getCityValue: PropTypes.func,
	}

	static defaultProps = {
		_showOrhide: () => {},
		getCityValue: () => {},
	}

	constructor(props) {
		super(props)
		this.state = {
			cityIndex: { cityId: 2, addressCode: 310100, name: '上海', address: '' },
			status: 100,
		}
	}

	componentDidMount() {
		if (!UtilDevice.isApp()) {
			this.setState({
				status: 200,
			})
		} else {
			this.checkLocation()
		}
	}

	checkLocation() {
		Bridge.appGetLocation((result) => {
			//alert(result.status)
			if (+result.status === 200) {
				this.setState({
					cityIndex: {
						cityId: 0,
						addressCode: result.adCode,
						name: result.cityName,
						address: result.address,
					},
					status: result.status,
				})
			} else {
				this.setState({
					status: result.status,
				})
			}
		})
	}

	openLocation() {
		this.setState(
			{
				status: 100,
			},
			() => {
				UtilPhone.appLocationPermissions((result) => {
					//alert('result: ' + JSON.stringify(result));
					if (+result.status === 200) {
						this.setState({
							cityIndex: {
								cityId: 0,
								addressCode: result.adCode,
								name: result.cityName,
								address: result.address,
							},
							status: result.status,
						})
					} else {
						this.setState({
							status: result.status,
						})
					}
				})
			},
		)
	}

	reloadLocation() {
		let that = this
		this.setState(
			{
				status: 100,
			},
			() => {
				that.checkLocation()
			},
		)
	}

	getCityValue(list) {
		try {
			this.props.getCityValue(list)
		} catch (e) {
			console.log('暂无回调方法')
		}
	}

	_selectCity(e) {
		// let target = e.target.className;
		// if (target == 'city-select-location-conent-loaction-refesh') {
		//     if (PhoneUtil.isInApp()) {
		//         this.reloadLocation();
		//     }
		//     return;
		// }
		let value = this.state.cityIndex

		this.getCityValue(value)

		this.props._showOrhide()
	}

	render() {
		const { cityIndex, status } = this.state

		return (
			<React.Fragment>
				<style dangerouslySetInnerHTML={{ __html: Style }} />
				<div className='component_city-select-location'>
					<div className='city-select-location-head'>当前</div>
					<div className='city-select-location-conent'>
						{+status === 200 && (
							<div
								className='city-select-location-successed'
								onClick={(e) => this._selectCity(e)}
							>
								<div className='city-select-location-conent-one-line'>
									<div className='city-select-location-conent-one-line-l'>
										<img
											alt='loading'
											src={LOADING_PNG}
											className='city-select-location-conent-loaction-logo'
										/>
										<b style={{ verticalAlign: 'middle' }}>{cityIndex.name}</b>
										<img
											alt='refresh'
											className='city-select-location-conent-loaction-refesh'
											src={REFRESH_PNG}
										/>
									</div>
									<div className='city-select-location-conent-one-line-r'>
										<img
											alt='choose'
											className='city-select-location-conent-loaction-status'
											src={CHOOSE_PNG}
										/>
									</div>
								</div>
								<div className='city-select-location-conent-two-line'>
									{cityIndex.address}
								</div>
							</div>
						)}

						{+status === 202 && (
							<div className='city-select-location-conent-one-line'>
								<div
									className='city-select-location-conent-one-line-l'
									onClick={() => this.reloadLocation()}
								>
									<img
										alt='refreshyellow'
										src={REFRESHYELLOW_PNG}
										className='city-select-location-conent-refresh-new-logo'
									/>
									<b style={{ verticalAlign: 'middle' }}>定位失败，点击刷新</b>
								</div>
							</div>
						)}

						{+status === 100 && (
							<div className='city-select-location-conent-one-line'>
								<div className='city-select-location-conent-one-line-l'>
									<img
										alt='loading'
										src={LOADING_PNG}
										className='city-select-location-conent-loading-logo'
									/>
									<b style={{ verticalAlign: 'middle' }}>定位中...</b>
								</div>
							</div>
						)}

						{+status === 201 && (
							<div className='city-select-location-conent-one-line'>
								<div
									className='city-select-location-conent-one-line-l'
									onClick={() => this.openLocation()}
								>
									<img
										alt='warn'
										src={WARN_PNG}
										className='city-select-location-conent-warn-logo'
									/>
									<b style={{ verticalAlign: 'middle' }}>定位未开启</b>
								</div>
							</div>
						)}
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default Location
